// UserContext.tsx
import { createContext, useContext } from 'react'

export interface User {
  id: string
  name: string
  email: string
  isAdmin: boolean
  organizationId?: string
  // other user properties
}

export const UserContext = createContext<User | null>(null)

export const UserProvider = UserContext.Provider

export function useUser() {
  const context = useContext(UserContext)
  if (context === null) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}
